<template>
  <div class="huay-container">
    <!-- Modern Header -->
    <div class="header-section">
      <div class="header-content">
        <div class="logo-section">
          <img src="../assets/images/logo2.png" class="logo" loading="lazy" />
        </div>
        <div class="brand-info">
          <h2 class="brand-name">UFA Easy888</h2>
          <div class="user-code">{{ code }}</div>
        </div>
        <div class="user-avatar-section">
          <div
            class="user-avatar"
            :style="{ 'background-image': `url(${pictureUrl})` }"
          ></div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Title Section -->
      <div class="page-title-section">
        <h1 class="page-title">
          <md-icon class="title-icon">confirmation_number</md-icon>
          แทงหวยสองตัวล่าง
        </h1>

        <!-- Quota Card -->
        <div class="quota-card">
          <div class="quota-header">
            <md-icon class="quota-icon">assessment</md-icon>
            <span class="quota-label">สิทธิ์การเล่น</span>
          </div>
          <div class="quota-stats">
            <div class="quota-item">
              <span class="quota-number">{{ countQTY }}</span>
              <span class="quota-text">ตัวเลขที่เลือก</span>
            </div>
            <div class="quota-divider">/</div>
            <div class="quota-item">
              <span class="quota-number">{{ QTY }}</span>
              <span class="quota-text">สิทธิ์ทั้งหมด</span>
            </div>
          </div>
          <div class="quota-progress">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{
                  width: QTY > 0 ? (countQTY / QTY) * 100 + '%' : '0%'
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Instructions Card -->
      <md-card class="instruction-card" v-if="QTY === 0">
        <div class="no-quota-content">
          <md-icon class="no-quota-icon">info</md-icon>
          <h3>ไม่มีสิทธิ์ในการเล่น</h3>
          <p>กรุณาฝากเงินขั้นต่ำ 150 บาท เพื่อรับสิทธิ์ 1 ตัวเลข</p>
          <router-link to="/deposit" class="deposit-link">
            <md-button class="md-raised md-primary">ไปหน้าฝากเงิน</md-button>
          </router-link>
        </div>
      </md-card>

      <!-- Number Selection Grid -->
      <md-card class="numbers-card" v-if="QTY > 0">
        <div class="card-header">
          <md-icon class="header-icon">grid_on</md-icon>
          <span class="header-title">เลือกตัวเลข</span>
          <span class="header-subtitle">(กดเพื่อเลือกตัวเลขที่ต้องการ)</span>
        </div>

        <div class="numbers-grid">
          <div class="number-row" v-for="index in rows" :key="index">
            <button
              v-for="col in 5"
              :key="col"
              :class="[
                'number-btn',
                { selected: huays[renderNumber(index, col - 1)] }
              ]"
              @click="selectNumber(renderNumber(index, col - 1))"
              :disabled="
                !huays[renderNumber(index, col - 1)] && countQTY >= QTY
              "
            >
              <span class="number-text">{{
                renderNumber(index, col - 1)
              }}</span>
              <div class="number-ripple"></div>
            </button>
          </div>
        </div>
      </md-card>

      <!-- Selected Numbers Summary -->
      <md-card class="summary-card" v-if="countQTY > 0">
        <div class="summary-header">
          <md-icon class="summary-icon">playlist_add_check</md-icon>
          <span class="summary-title">ตัวเลขที่เลือก</span>
        </div>
        <div class="selected-numbers">
          <div
            v-for="(selected, number) in selectedHuays"
            :key="number"
            class="selected-number"
            @click="selectNumber(number)"
          >
            <span class="selected-text">{{ number }}</span>
            <md-icon class="remove-icon">close</md-icon>
          </div>
        </div>
      </md-card>

      <!-- Submit Button -->
      <div class="submit-section" v-if="isShow && QTY > 0">
        <md-button
          class="submit-button md-raised md-primary"
          @click="confirm()"
          :disabled="isDisabled || countQTY === 0"
        >
          <md-icon v-if="!isDisabled">send</md-icon>
          <md-progress-spinner
            v-if="isDisabled"
            :md-diameter="20"
            :md-stroke="2"
            md-mode="indeterminate"
          ></md-progress-spinner>
          {{ loading }}
        </md-button>

        <p class="submit-note">
          <md-icon class="note-icon">schedule</md-icon>
          สามารถแทงได้เฉพาะวันที่ 1 และ 16 ของทุกเดือน ก่อนเวลา 15:20 น.
        </p>
      </div>

      <!-- Time Restriction Message -->
      <md-card class="restriction-card" v-if="!isShow">
        <div class="restriction-content">
          <md-icon class="restriction-icon">access_time</md-icon>
          <h3>ปิดรับแทงหวยแล้ว</h3>
          <p>
            สามารถแทงหวยได้เฉพาะวันที่ 1 และ 16 ของทุกเดือน ก่อนเวลา 15:20 น.
          </p>
        </div>
      </md-card>

      <!-- Spacer for bottom menu -->
      <div style="height: 80px;"></div>
    </div>

    <!-- Bottom Menu -->
    <BottomMenu></BottomMenu>
  </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import moment from "moment-timezone";
import router from "./../router";
import liffService from "@/services/liff";
export default {
  name: "Huay",
  components: {
    BottomMenu: require("./BottomMenu").default
  },
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
    if (
      Number(
        moment()
          .tz("Asia/Bangkok")
          .format("D")
      ) === 1 ||
      Number(
        moment()
          .tz("Asia/Bangkok")
          .format("D")
      ) === 16
    ) {
      if (
        Number(
          moment()
            .tz("Asia/Bangkok")
            .format("H") +
            "" +
            moment()
              .tz("Asia/Bangkok")
              .format("mm")
        ) <= 1520
      ) {
        this.isShow = true;
      }
    }
  },
  computed: {
    selectedHuays() {
      const result = {};
      for (const number in this.huays) {
        if (this.huays[number]) {
          result[number] = this.huays[number];
        }
      }
      return result;
    }
  },
  data() {
    return {
      pictureUrl: "",
      name: "",
      isDisabled: false,
      isShow: false,
      error: 0,
      code: "",
      huays: [],
      rows: 20,
      QTY: 0,
      countQTY: 0,
      loading: "ยืนยันแทงหวย",
      userId: ""
    };
  },
  methods: {
    selectNumber(num) {
      if (this.huays[num]) {
        this.huays[num] = false;
        this.countQTY--;
      } else if (this.QTY > this.countQTY) {
        this.huays[num] = true;
        this.countQTY++;
      }
      this.rows++;
      this.rows--;
    },
    renderClass(row, i) {
      const num = this.renderNumber(row, i);
      if (this.huays[num]) {
        return "button1 active2";
      } else {
        return "button1";
      }
    },
    renderNumber(row, i) {
      const num = (row - 1) * 5 + i;
      if (num.toString().length == 1) {
        return "0" + num;
      } else {
        return num.toString();
      }
    },
    async confirm() {
      if (Object.keys(this.huays).length <= this.QTY) {
        this.loading = "กำลังประมวลผล...";
        this.isDisabled = true;
        const huays = [];
        let lotto = "";
        for (const x in this.huays) {
          if (this.huays[x]) {
            huays.push(x);
            lotto += lotto ? ", " + x : x;
          }
        }
        firebase
          .firestore()
          .collection("huays")
          .doc(
            this.userId +
              "-" +
              moment()
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD")
          )
          .set({
            huays,
            userId: this.userId,
            updatetime: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
            date: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD")
          })
          .then(async () => {
            this.isDisabled = false;
            await window.liff.sendMessages([
              {
                type: "flex",
                altText: "แทงหวยสองตัวล่าง",
                contents: {
                  type: "bubble",
                  size: "kilo",
                  body: {
                    type: "box",
                    layout: "vertical",
                    contents: [
                      {
                        type: "text",
                        text: "LOTTO",
                        weight: "bold",
                        color: "#1DB446",
                        size: "sm"
                      },
                      {
                        type: "text",
                        text: "UFA Easy888",
                        weight: "bold",
                        size: "xxl",
                        margin: "md"
                      },
                      {
                        type: "text",
                        text: this.code,
                        size: "xs",
                        color: "#aaaaaa",
                        wrap: true
                      },
                      {
                        type: "separator",
                        margin: "lg"
                      },
                      {
                        type: "box",
                        layout: "vertical",
                        margin: "lg",
                        contents: [
                          {
                            type: "box",
                            layout: "horizontal",
                            contents: [
                              {
                                type: "text",
                                text: "สองตัวล่าง",
                                size: "md",
                                color: "#555555",
                                decoration: "underline",
                                align: "center"
                              }
                            ]
                          },
                          {
                            type: "box",
                            layout: "horizontal",
                            contents: [
                              {
                                type: "text",
                                text: lotto,
                                size: "md",
                                color: "#555555",
                                maxLines: 20,
                                adjustMode: "shrink-to-fit",
                                wrap: true
                              }
                            ],
                            paddingTop: "15px"
                          }
                        ]
                      },
                      {
                        type: "image",
                        url:
                          "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Flogo2.png?alt=media",
                        position: "absolute",
                        offsetTop: "0px",
                        offsetEnd: "5px",
                        size: "xs"
                      }
                    ]
                  },
                  styles: {
                    footer: {
                      separator: true,
                      separatorColor: "#000000"
                    }
                  }
                }
              }
            ]);
            window.liff.closeWindow();
          });
      } else {
        alert("โปรดตรวจสอบสิทธิ์จำนวนที่แทง");
      }
    },
    addCommasInNubmer: value => {
      let num, oneDigit, str;
      if (typeof value === "number") {
        num = value.toFixed(2);
      } else {
        num = value;
      }

      str = num.toString().split(".");
      if (str[0].length >= 4) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
      }
      if (str[1]) {
        oneDigit = str[1].split("");
        if (str[1] === "00") {
          str = str[0];
        } else if (oneDigit[1] === "0") {
          str[1] = oneDigit[0];
          str = str.join(".");
        } else {
          str = str.join(".");
        }
      } else {
        str = str[0];
      }
      return str;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
          router.replace("/register");
        } else {
          let user = {};
          let key = "";
          for (const x in users) {
            user = users[x];
            key = x;
          }
          this.code = user.code;
          this.sendMessageLine2("สนใจโปรเข้า Win 😘😘");
          firebase
            .firestore()
            .collection("krungsri")
            .where(
              "date",
              ">=",
              moment()
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD") + " 00:00:00"
            )
            .where("type", "==", "ฝาก")
            .where("userId", "==", this.userId)
            .get()
            .then(snapshot => {
              let deposit = 0;
              snapshot.forEach(doc => {
                deposit += Number(
                  doc
                    .data()
                    .qty.toString()
                    .replace(",", "")
                );
              });
              const qty = Math.floor(deposit / 150);
              this.QTY = qty;
              if (qty) {
                firebase
                  .firestore()
                  .collection("huays")
                  .doc(
                    this.userId +
                      "-" +
                      moment()
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD")
                  )
                  .get()
                  .then(doc => {
                    if (doc.exists) {
                      if (doc.data().huays) {
                        for (const x in doc.data().huays) {
                          const xx = doc.data().huays[x];
                          this.huays[xx] = true;
                        }
                        this.countQTY = doc.data().huays.length;
                      }
                    }
                  });
              }
            });
        }
      }
    },
    async sendMessageLine2(text) {
      await window.liff.sendMessages([
        {
          type: "text",
          text: text
        }
      ]);
    }
  }
};
</script>

<style lang="scss" scoped>
.huay-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  color: #ffffff;
  padding-bottom: 60px;
}

// Header Section (same as other pages)
.header-section {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 600px;
  margin: 0 auto;
}

.logo-section {
  flex: 0 0 auto;
}

.logo {
  height: 60px;
  width: auto;
}

.brand-info {
  flex: 1;
  text-align: center;
  padding: 0 1rem;
}

.brand-name {
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0;
  background: linear-gradient(45deg, #FF6B35, #FF9165);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.user-code {
  font-size: 0.9rem;
  color: #FF9165;
  margin-top: 0.25rem;
}

.user-avatar-section {
  flex: 0 0 auto;
}

.user-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  border: 2px solid #FF6B35;
  box-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
}

// Main Content
.main-content {
  padding: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

// Page Title
.page-title-section {
  margin: 1.5rem 0;
}

.page-title {
  font-size: 1.5rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0 0 1rem 0;
}

.title-icon {
  color: #FF6B35 !important;
}

// Quota Card
.quota-card {
  background: linear-gradient(135deg, #FF6B35 0%, #FF9165 100%);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
  margin-bottom: 1.5rem;
}

.quota-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;

  .quota-icon {
    color: rgba(0, 0, 0, 0.8) !important;
  }

  .quota-label {
    font-size: 1.1rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
  }
}

.quota-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.quota-item {
  text-align: center;

  .quota-number {
    display: block;
    font-size: 2rem;
    font-weight: bold;
    color: #000;
    line-height: 1;
  }

  .quota-text {
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.7);
    margin-top: 0.25rem;
  }
}

.quota-divider {
  font-size: 1.5rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.5);
}

.quota-progress {
  .progress-bar {
    width: 100%;
    height: 8px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    overflow: hidden;

    .progress-fill {
      height: 100%;
      background: linear-gradient(90deg, #4caf50 0%, #66bb6a 100%);
      border-radius: 4px;
      transition: width 0.3s ease;
    }
  }
}

// Cards
.md-card {
  background: linear-gradient(135deg, #1a1a1a 0%, #252525 100%) !important;
  border: 1px solid rgba(255, 107, 53, 0.2);
  border-radius: 12px !important;
  margin-bottom: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5) !important;
}

// Instruction Card
.instruction-card {
  padding: 2rem !important;
}

.no-quota-content {
  text-align: center;

  .no-quota-icon {
    font-size: 4rem !important;
    color: rgba(255, 107, 53, 0.5) !important;
    margin-bottom: 1rem;
  }

  h3 {
    color: #ffffff;
    margin-bottom: 1rem;
  }

  p {
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }
}

.deposit-link {
  text-decoration: none;

  .md-button {
    background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
    color: #ffffff !important;
  }
}

// Numbers Card
.numbers-card {
  padding: 1.5rem !important;
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
  text-align: center;

  .header-icon {
    color: #FF6B35 !important;
    font-size: 2rem !important;
    margin-bottom: 0.5rem;
  }

  .header-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.25rem;
  }

  .header-subtitle {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.6);
  }
}

.numbers-grid {
  .number-row {
    display: flex;
    justify-content: space-around;
    margin-bottom: 0.75rem;
    gap: 0.5rem;
  }
}

.number-btn {
  position: relative;
  width: 60px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover:not(:disabled) {
    background: rgba(255, 107, 53, 0.2);
    border-color: rgba(255, 107, 53, 0.5);
    transform: translateY(-2px);
  }

  &.selected {
    background: linear-gradient(135deg, #FF6B35 0%, #FF9165 100%);
    border-color: #FF9165;
    color: #000;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }

  .number-text {
    position: relative;
    z-index: 2;
  }

  .number-ripple {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
  }

  &:active:not(:disabled) .number-ripple {
    width: 100px;
    height: 100px;
  }
}

// Summary Card
.summary-card {
  padding: 1.5rem !important;
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;

  .summary-icon {
    color: #4caf50 !important;
  }

  .summary-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #ffffff;
  }
}

.selected-numbers {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.selected-number {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%);
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #f44336 0%, #ff6b6b 100%);
    transform: scale(1.05);
  }

  .remove-icon {
    font-size: 1rem !important;
  }
}

// Submit Section
.submit-section {
  margin-top: 2rem;
}

.submit-button {
  width: 100% !important;
  background: linear-gradient(135deg, #4caf50 0%, #66bb6a 100%) !important;
  color: #ffffff !important;
  font-size: 1.1rem !important;
  font-weight: 600 !important;
  padding: 0.875rem !important;
  border-radius: 25px !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
  margin-bottom: 1rem;

  &:disabled {
    background: linear-gradient(135deg, #666 0%, #888 100%) !important;
    box-shadow: none !important;
  }

  .md-icon {
    margin-right: 0.5rem;
  }
}

.submit-note {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.85rem;
  text-align: left;
  margin: 0;
  line-height: 1.4;

  .note-icon {
    font-size: 1rem !important;
    color: rgba(255, 255, 255, 0.5) !important;
    margin-top: 0.1rem;
    flex-shrink: 0;
  }
}

// Restriction Card
.restriction-card {
  padding: 2rem !important;
}

.restriction-content {
  text-align: center;

  .restriction-icon {
    font-size: 4rem !important;
    color: rgba(244, 67, 54, 0.5) !important;
    margin-bottom: 1rem;
  }

  h3 {
    color: #ffffff;
    margin-bottom: 1rem;
  }

  p {
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.6;
  }
}

// Responsive
@media (max-width: 375px) {
  .number-btn {
    width: 55px;
    height: 45px;
    font-size: 1rem;
  }

  .quota-stats {
    gap: 0.5rem;

    .quota-item .quota-number {
      font-size: 1.75rem;
    }
  }
}

@media (max-width: 320px) {
  .number-btn {
    width: 50px;
    height: 42px;
    font-size: 0.95rem;
  }

  .numbers-grid .number-row {
    gap: 0.25rem;
  }
}
</style>

<style>
/* Global overrides for Material Design components */
.huay-container .md-theme-default.md-field:before {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.huay-container .md-theme-default.md-field:after {
  background-color: #FF6B35 !important;
}

.huay-container .md-progress-spinner {
  color: #ffffff !important;
}
</style>
